import { combineReducers } from 'redux';
import { Ref_bike_lead } from './ref_bike_lead.reducer';
import { Ref_lead_customer } from './ref_lead_customer.reducer';
import { Lead_marketing } from './marketing.reducer';
import { Lead_valuations } from './lead_valuations.reducer';
import { Lead_mot_history } from './mot_history.reducer';
import { Lead_cap_valuation } from './cap_valuation.reducer';
import { Reference_bike } from './reference_bike.reducer';
import { Lead_existing_stock } from './lead_existing_stock.reducer';
import { Lead_notes } from './lead_notes.reducer';
import { Lead_general } from './lead_general.reducer';
import { Lead_photos } from './lead_profile_photos.reducers';
import { Lead_transport } from './transport_modal.reducers';
import { Lead_blemish_report } from './lead_blemish_report.reducer';
import { Customer_name } from './customer_name.reducers';
import { leadHistory } from './leadHistory.reducer';
import { leadConversation } from './lead_conversation.reducers';
import { leadDisposition } from './lead_disposition.reducer';

export const Lead_profile = combineReducers({
    Ref_bike_lead,
    Ref_lead_customer,
    Lead_marketing,
    Lead_valuations,
    Lead_mot_history,
    Lead_cap_valuation,
    Lead_existing_stock,
    Lead_notes,
    Lead_general,
    Lead_photos,
    Lead_transport,
    Lead_blemish_report,
    Reference_bike,
    Customer_name,
    leadHistory,
    leadDisposition,
    leadConversation,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/index.js